import { GLOBAL } from 'saddlebag-browser';

export const isAcornRequest = (): boolean => {
  const $window = GLOBAL.getWindow();
  return $window.__internal?.isAcornRequest || false;
};

// It is a common type guard function for parameter types of acorn and banana
export const isAcornType = <AcornType, BananaType>(
  param: AcornType | BananaType,
): param is AcornType => isAcornRequest();
